module.exports = __webpack_public_path__ + "img/facebook_fans_landscape.7d121247.png";